import { useTranslation } from "next-i18next";
import { useFormContext } from "react-hook-form";

import { Label } from "@/features/common/components/tailwind/Label";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/features/common/components/tailwind/RadioGroup";
import { CardPayment } from "@/features/subscription/components/CardPayment";
import { useUserContext } from "@/features/user/contexts/useUserContext";
import {
  FeatureNameEnum,
  useUserPaymentMethodsQuery,
  PaymentMethodStatusEnum,
  PaymentMethodProviderEnum,
} from "@/generated/generated-hooks";
import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  paymentMethod: { limit },
} = getPublicConfig();

export const TipsByStripeView = () => {
  const { t } = useTranslation(["tips", "subscriptionPlan", "common"]);
  const { register, control } = useFormContext();
  const { ready, user } = useUserContext();
  const { data, loading, error } = useUserPaymentMethodsQuery({
    variables: {
      userId: user._id,
      paymentMethodProvider: PaymentMethodProviderEnum.Stripe2,
      paymentMethodStatus: [
        PaymentMethodStatusEnum.Default,
        PaymentMethodStatusEnum.Active,
      ],
    },
    skip: !ready || !user,
    ssr: false,
  });

  const canAddPaymentMethod = data?.userPaymentMethods?.length < limit;

  const onClickPaymentMethod = (value: string) => {
    // setUserPaymentMethodId(value);
  };

  const getPaymentMethodList = () => {
    if (!data || loading) return null;
    return data.userPaymentMethods.map((paymentMethods) => {
      const { _id, paymentMethodDetail, paymentMethodStatus } = paymentMethods;

      if (!paymentMethodDetail?.card) return null;
      const { lastFourDigits, brand, expYear, expMonth } =
        paymentMethodDetail.card;

      return (
        <CardPayment
          key={_id}
          userPaymentMethodId={_id}
          lastFourDigits={lastFourDigits}
          brand={brand}
          expMonth={expMonth}
          expYear={expYear}
        />
      );
    });
  };

  return (
    <RadioGroup
      onValueChange={onClickPaymentMethod}
      className="mt-4"
      defaultValue={data.userPaymentMethods[0]?._id}
    >
      {/* card options. */}
      {getPaymentMethodList()}

      {canAddPaymentMethod && (
        <>
          <div className="flex items-center mb-2">
            <RadioGroupItem
              value={undefined}
              id="newPaymentMethod"
              aria-label="new card form"
            />
            <Label htmlFor="newPaymentMethod" className="touchable">
              {t("common:paymentForm.new")}
            </Label>
          </div>
        </>
      )}
    </RadioGroup>
  );
};
